import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { getOneClickTimeWindows } from '@ordersnproducts/modules/one-click-order/selectors/one-click-time-windows.selector';

@Injectable()
export class OneClickSetTimeWindow implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickTimeWindows)
        .pipe(
          filter((timeWindows) => !!timeWindows.length),
          take(1),
          map((timeWindows) => timeWindows.find((item) => item.timeWindowId === value)),
          switchMap((timeWindow) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, timeWindow })),
            ),
          ),
        )
        .subscribe(({ order, timeWindow }) => {
          const modded: Order = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return {
                  ...item,
                  timeWindowId: timeWindow.timeWindowId,
                  timeWindowCode: timeWindow.timeWindowCode,
                  timeWindowDesc: timeWindow.timeWindowDesc,
                };
              } else {
                return item;
              }
            }),
          };

          this.store.dispatch(new OneClickUpdateOrderAction(modded));
        });
    }
  }
}
